import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { adminApi } from "../../lib/adminApi";
import { toast } from "sonner";

export default function Prompts() {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ slug: "", name: "", template: "", variables: "" });

  const fetchPrompts = async () => {
    setLoading(true);
    try {
      const data = await adminApi.getPrompts();
      setPrompts(data.data);
    } catch (e) {
      toast.error(e.message);
    }
    setLoading(false);
  };

  useEffect(() => { fetchPrompts(); }, []);

  const handleCreate = async () => {
    try {
      await adminApi.createPrompt({
        ...form,
        variables: form.variables ? form.variables.split(",").map(v => v.trim()) : null
      });
      toast.success("Prompt created");
      setShowCreate(false);
      setForm({ slug: "", name: "", template: "", variables: "" });
      fetchPrompts();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Deactivate this prompt?")) return;
    try {
      await adminApi.deletePrompt(id);
      toast.success("Prompt deactivated");
      fetchPrompts();
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Prompts ({prompts.length})</h1>
        <Dialog open={showCreate} onOpenChange={setShowCreate}>
          <DialogTrigger asChild>
            <Button>Create Prompt</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>New Prompt</DialogTitle></DialogHeader>
            <div className="space-y-4">
              <Input placeholder="Slug (e.g. product_mockup)" value={form.slug} onChange={(e) => setForm({...form, slug: e.target.value})} />
              <Input placeholder="Name" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} />
              <Textarea placeholder="Template..." rows={6} value={form.template} onChange={(e) => setForm({...form, template: e.target.value})} />
              <Input placeholder="Variables (comma-separated)" value={form.variables} onChange={(e) => setForm({...form, variables: e.target.value})} />
              <Button onClick={handleCreate} className="w-full">Create</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {loading ? (
        <div className="text-center py-8">Loading...</div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead>
              <TableHead>Slug</TableHead>
              <TableHead>Name</TableHead>
              <TableHead>Variables</TableHead>
              <TableHead>Updated</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {prompts.map((prompt) => (
              <TableRow key={prompt.id}>
                <TableCell>{prompt.id}</TableCell>
                <TableCell className="font-mono text-sm">{prompt.slug}</TableCell>
                <TableCell>{prompt.name}</TableCell>
                <TableCell>{prompt.variables?.join(", ") || "-"}</TableCell>
                <TableCell>{new Date(prompt.updated_at).toLocaleDateString()}</TableCell>
                <TableCell>
                  <div className="flex gap-2">
                    <Link to={`/admin/prompts/${prompt.id}`}>
                      <Button variant="outline" size="sm">Edit</Button>
                    </Link>
                    <Button variant="destructive" size="sm" onClick={() => handleDelete(prompt.id)}>
                      Deactivate
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
